<ng-template #cardTemplate>
  <div *ngFor="let item of items$ | async">
    <app-user-field-slot [userField]="item"></app-user-field-slot>
  </div>
</ng-template>

<app-list title="User fields" [actions]="actions" [cardTemplate]="cardTemplate" i18n-title>
</app-list>
